import Button from '../common/Button';

function AboutPreview() {
  return (
    <section className="about-preview" aria-labelledby="about-preview-title">
      <div className="container about-preview__grid">
        <div
          className="about-preview__image"
          style={{ '--about-image': `url(${process.env.PUBLIC_URL}/images/landing-img4.png)` }}
          aria-label="Company photography"
        />
        <div className="about-preview__copy">
          <p className="eyebrow">About Us</p>
          <h2 id="about-preview-title">Reliable industrial repair support.</h2>
          <p>
            We focus on industrial gearbox and hydraulic repair work for customers across Canada.
          </p>
          <Button to="/about">Learn More About Us</Button>
        </div>
        <div className="about-preview__points" aria-label="Company service priorities">
          <article>
            <img src={`${process.env.PUBLIC_URL}/icons/technician.svg`} alt="" aria-hidden="true" />
            <h3>Repair Focused</h3>
            <p>Focused on gearbox, hydraulic, and mechanical repair needs.</p>
          </article>
          <article>
            <img src={`${process.env.PUBLIC_URL}/icons/quality-assured.svg`} alt="" aria-hidden="true" />
            <h3>Quality Minded</h3>
            <p>Repair work guided by practical inspection, clear communication, and dependable workmanship.</p>
          </article>
          <article>
            <img src={`${process.env.PUBLIC_URL}/icons/customer-focused.svg`} alt="" aria-hidden="true" />
            <h3>Canada-Wide Service</h3>
            <p>Serving industrial customers across Canada.</p>
          </article>
        </div>
      </div>
    </section>
  );
}

export default AboutPreview;
